module.exports = __webpack_public_path__ + "static/media/dragHandle.f71ad6b9.svg";